/**
 * LayerDrawerToggle Component
 *
 * Map control button that opens the Layer Drawer when clicked.
 * Only visible when the drawer is hidden.
 */

import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { useLayerDrawer } from '../LayerDrawerContext';
import { DrawerHeight } from '../utils/layerDrawerUtils';
import './LayerDrawerToggle.scss';

export const LayerDrawerToggle: React.FC = () => {
  const { drawerHeight, setDrawerHeight } = useLayerDrawer();

  /**
   * Open the drawer to full height
   */
  const handleClick = useCallback(() => {
    setDrawerHeight(DrawerHeight.FULL);
  }, [setDrawerHeight]);

  // Only show when drawer is hidden
  if (drawerHeight !== DrawerHeight.HIDDEN) {
    return null;
  }

  return (
    <button
      className="layer-drawer-toggle"
      onClick={handleClick}
      aria-label="Open layer drawer"
      title="Layers"
    >
      <FontAwesomeIcon icon={faLayerGroup} />
    </button>
  );
};
